(function(){
  var prog=document.getElementById('ilha-progresso');
  if(!prog){return;}
  var track=document.getElementById('ilha-prog-track');
  var fill=document.getElementById('ilha-prog-fill');
  var hdr=document.querySelector('sticky-header')||document.querySelector('.header-wrapper')||document.querySelector('header.header');
  var len=track.getTotalLength();
  fill.style.strokeDasharray=len;
  function up(){
    if(hdr){
      var hb=hdr.getBoundingClientRect().bottom;
      prog.style.top=(hb>0?hb:0)+'px';
    }
    var h=document.documentElement.scrollHeight-window.innerHeight;
    var p=h>0?Math.min(window.scrollY/h,1):0;
    fill.style.strokeDashoffset=len*(1-p);
  }
  up();
  addEventListener('scroll',up,{passive:true});
  addEventListener('resize',up);
})();
